import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto' // Instantané, pas d'animation
    });
  };

  useEffect(() => {
    // Désactiver la restauration automatique du scroll du navigateur
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }

    // Scroll immédiat et instantané
    scrollToTop();

    // Sécurité : refait un scroll après rendu pour éviter position milieu
    const timeout = setTimeout(scrollToTop, 0);

    return () => clearTimeout(timeout);
  }, [pathname, search, hash]); // Réagit aussi aux changements de paramètres et hash

  // Écouter les changements d'état dans la même page (modals, étapes, etc.)
  useEffect(() => {
    const handleStateChange = () => {
      scrollToTop();
    };

    const handleModalOpen = () => {
      scrollToTop();
    };

    const handleStepChange = () => {
      scrollToTop();
    };

    // Écouter les changements d'état du navigateur
    window.addEventListener('popstate', handleStateChange);
    
    // Écouter les changements de hash pour les ancres
    window.addEventListener('hashchange', handleStateChange);
    
    // Écouter les événements personnalisés pour les modals et étapes
    window.addEventListener('modalOpened', handleModalOpen);
    window.addEventListener('stepChanged', handleStepChange);
    window.addEventListener('scrollToTop', handleModalOpen);
    
    return () => {
      window.removeEventListener('popstate', handleStateChange);
      window.removeEventListener('hashchange', handleStateChange);
      window.removeEventListener('modalOpened', handleModalOpen);
      window.removeEventListener('stepChanged', handleStepChange);
      window.removeEventListener('scrollToTop', handleModalOpen);
    };
  }, []);

  return null;
};

export default ScrollToTop;
